import React from 'react';
import { Spin } from 'antd';
import s from './s.module.less';
import StickyBannerContentItem from './StickyBannerContentItem';
import {
    DataManager,
    TabDataManager,
} from '../../utils/dataUpdater';
import { TStickyBannerMgmt } from '../../type';
import StickyBannerContentModal from './StickyBannerContentModal';
import { ServerMeta } from 'types/common';

type Props = {
    dataManager: DataManager;
    condition?: ServerMeta;
};

const StickyBannerMgmt = ({ dataManager, condition }: Props) => {
    const [loading] = React.useState(false);
    const [contentModalVisible, setContentModalVisible] = React.useState(false);

    // 为stickyBannerMgmt tab创建独立的数据管理器
    const [stickyBannerTabManager] = React.useState<TabDataManager>(() => {
        return dataManager.createTabManager('stickyBannerMgmt');
    });

    // 从tab数据管理器获取stickyBannerMgmt数据
    const stickyBannerMgmtData = stickyBannerTabManager.getTabData('stickyBannerMgmt');

    const handleStickyBannerSave = async (data: TStickyBannerMgmt) => {
        try {
            // 更新sticky banner数据
            stickyBannerTabManager.updateTabData('title', data.title);
            stickyBannerTabManager.updateTabData('subText', data.subText);
            stickyBannerTabManager.updateTabData('callToActionName', data.callToActionName);
            stickyBannerTabManager.updateTabData('callToActionLink', data.callToActionLink);
            stickyBannerTabManager.updateTabData('image', data.image);

            // 保存到服务器
            await dataManager.saveDataToServer(
                () => {
                    setContentModalVisible(false);
                },
                (error: any) => {
                    console.error('Failed to save sticky banner:', error);
                },
            );
        } catch (error) {
            console.error('Error in handleStickyBannerSave:', error);
        }
    };

    const handleContentEdit = () => {
        setContentModalVisible(true);
    };

    return (
        <div className={s.wrap}>
            <div className={s.title}>
                Sticky banner management
            </div>

            <Spin spinning={loading}>
                <div className={s.contentSection}>
                    <StickyBannerContentItem
                        banner={stickyBannerMgmtData}
                        condition={condition}
                        onEdit={() => handleContentEdit()}
                    />
                </div>
            </Spin>

            {/* Sticky Banner Content Modal */}
            <StickyBannerContentModal
                visible={contentModalVisible}
                onCancel={() => {
                    setContentModalVisible(false);
                }}
                onSave={handleStickyBannerSave}
                condition={condition}
                banner={stickyBannerMgmtData}
            />
        </div>
    );
};

export default StickyBannerMgmt;
